import FullWidthLayout from "@/layouts/FullWidthLayout";
import { KPageIndex } from "kinnect-general";
import { Pageable } from "kinnect-mixins";

export default {
	name: "CompanyPage",

	metaInfo: { title: "Company" },

	mixins: [ Pageable ],

	data: () => ( {
		items: [
			{
				icon: "attach_money",
				title: "Bonus",
				to: { name: "bonus" }
			},
			{
				icon: "build",
				title: "Facility Maintenance",
				to: { name: "facilityMaintenance" }
			},
			{
				icon: "store",
				title: "Locations",
				to: { name: "locations" }
			},
			{
				icon: "donut_small",
				title: "Vision / Traction Organizer",
				to: { name: "vto" }
			},
			{
				icon: "extension",
				title: "3rd Party Services",
				to: { name: "thirdPartyServices" }
			},
			{
				icon: "open_in_new",
				target: "_blank",
				title: "Paycom",
				to: "https://www.paycomonline.net/v4/ee/web.php/app/login"
			}
		]
	} ),

	render() {
		return <FullWidthLayout>
			<KPageIndex
				autoSort={false}
				items={this.items}
			></KPageIndex>
		</FullWidthLayout>;
	}
};
